import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import axios from "axios";
import {
  JSON_BASE_API_URL,
  ROLL_CALL_API_BASE_URL,
} from "../../Pereco/RollCall/RollCallConfig/RollCallConfig";
import { Spin } from "antd";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ImagesCrousel = [
  {
    image: "assets/img/fallbackImages/vertical-1.jpeg",
    title: "Urban Threads",
    category: "Fashion · E-Commerce",
    description: "Minimal clothing brand with responsive online store",
  },
  {
    image: "assets/img/fallbackImages/vertical-2.jpeg",
    title: "Skyline Realty",
    category: "Real Estate · Branding",
    description: "Property showcase website with premium visual identity",
  },
  {
    image: "assets/img/fallbackImages/vertical-3.jpeg",
    title: "FitZone Gym",
    category: "Fitness · Mobile App",
    description: "Fitness management app with class booking and memberships",
  },
];
const ImagesCrouselVertical = [
  {
    image: "assets/img/fallbackImages/horiz-1.jpeg",
    title: "Fallback 1",
    category: "",
  },
  {
    image: "assets/img/fallbackImages/horiz-2.jpeg",
    title: "Fallback 2",
    category: "",
  },
];

const settings = {
  dots: true,
  infinite: true,
  speed: 600,
  autoplay: true,
  autoplaySpeed: 10000,
  pauseOnHover: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  responsive: [
    {
      breakpoint: 1600,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 1200, // Laptop
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 992, // Tablet
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 576, // Mobile
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const verticalSettings = {
  dots: true,
  infinite: true,
  speed: 600,
  autoplay: true,
  autoplaySpeed: 10000,
  pauseOnHover: true,

  vertical: true, // Enable vertical sliding
  verticalSwiping: true, // Optional: allow swipe up/down

  slidesToShow: 2,
  slidesToScroll: 1,
  arrows: false,

  responsive: [
    {
      breakpoint: 1600,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const carouselHeight = 420;

const Signin = () => {
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [Username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setloading] = useState(false);
  const navigate = useNavigate();
  const route = all_routes;

  const [featureCards, setFeatureCards] = useState([]);
  const [dataloading, setdataloading] = useState(false);
  const [featureCarouselSlides, setFeatureCarouselSlides] = useState([]);
  // const [title, setTitel] = useState([]);

  console.log(featureCards, "featureCards");
  useEffect(() => {
    const fetchData = async () => {
      setdataloading(true);

      try {
        const res = await axios.get(
          `${JSON_BASE_API_URL}/rollcalladmin-content`,
        );

        const data = res.data;

        // setTitel(data.titleSection || []);
        if (data.cards && data.cards.length > 0) {
          setFeatureCards(data.cards);
        } else {
          setFeatureCards(ImagesCrousel);
        }
        if (data.carousel && data.carousel.length > 0) {
          setFeatureCarouselSlides(data.carousel);
        } else {
          setFeatureCarouselSlides(ImagesCrouselVertical);
        }
      } catch (error) {
        console.error("Error fetching content:", error);

        // API failed
        setFeatureCarouselSlides(ImagesCrouselVertical);
        setFeatureCards(ImagesCrousel);
      } finally {
        setdataloading(false);
      }
    };

    fetchData();
  }, []);

  const togglePasswordVisibility = () => {
    setPasswordVisible((prev) => !prev);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setloading(true);

    try {
      const response = await axios.post(
        `${ROLL_CALL_API_BASE_URL}portal/user/login`,
        { username: Username, password: password },
      );

      const { ResultData } = response.data;
      const { Token, IsAdmin, SuperId } = ResultData;

      if (Token && IsAdmin && SuperId) {
        sessionStorage.setItem("authToken", Token);
        sessionStorage.setItem("userData", JSON.stringify(ResultData));
        sessionStorage.setItem("superId", SuperId);

        try {
          const menuResponse = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/access/getmenu?UserId=${ResultData.UserId}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Token}`,
              },
            },
          );

          const menuData = await menuResponse.json();

          if (menuData?.status && Array.isArray(menuData.ResultData)) {
            sessionStorage.setItem(
              "userMenu",
              JSON.stringify(menuData.ResultData),
            );

            const flatPermissions = {};
            const flatten = (items) => {
              items.forEach((item) => {
                if (item.link && item.link !== "#") {
                  flatPermissions[item.link] = {
                    canRead: item.canRead,
                    canWrite: item.canWrite,
                    canDelete: item.canDelete,
                    canExport: item.canExport,
                  };
                }
                if (
                  Array.isArray(item.submenuItems) &&
                  item.submenuItems.length > 0
                ) {
                  flatten(item.submenuItems);
                }
              });
            };

            flatten(menuData.ResultData);
            sessionStorage.setItem(
              "rollcall-permissions",
              JSON.stringify(flatPermissions),
            );
          }
        } catch (err) {
          console.error("Menu API error:", err);
        }

        navigate(`/${ResultData.DefaultPath}`);
      } else {
        alert("Access denied. Only Admins can access the dashboard.");
      }
    } catch (error) {
      alert("Login failed. Please check your credentials.");
      console.error("Login error:", error);
    } finally {
      setloading(false);
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    if (token) {
      navigate(route.rollcalldashboard, { replace: true });
    }
  }, [navigate]);

  return (
    <>
      {/* <div className="main-wrapper d-none">
        <div className="py-2" style={{ backgroundColor: "#FFE8BF" }}>
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-lg-2 col-md-3 col-6 text-center text-md-start">
                <ImageWithBasePath
                  src="assets/img/logo.png"
                  alt="logo"
                  className="img-fluid"
                  style={{ maxHeight: "60px" }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="account-content py-3">
          <Spin spinning={dataloading} size="large" tip="Loading...">
            <div className="container-fluid">
              <div className="row g-4">
                <div className="col-lg-6 d-flex flex-column">
                  <div className="flex-grow-1">
                    <div className="mb-2">
                      <h1
                        className="  mb-2 display-1"
                        style={{ color: "#BF1E24" }}
                      >
                        {title?.title || "Welcome to RollCall"}
                      </h1>
                      <h4 className="">{title?.subtitle}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Spin>
        </div>
      </div> */}

      <style>{`
        .bg-cream { background-color: #FBF3E3; }
        .bg-terracotta { background-color: #D96B2C; }
        .bg-terracotta-dark { background-color: #C25A22; }
        .bg-stat { background-color: #F3E3C6; }
        .bg-navy { background-color: #1E2A3A; }
        .bg-green { background-color: #2F4A3C; }
        .bg-blue-lt { background-color: #CFE4F0; }
        .bg-red { background-color: #B5342A; }
        .bg-charcoal { background-color: #2b2b2b; }

        .text-terracotta { color: #D96B2C; }
        .text-navy { color: #1E2A3A; }

        .border-terracotta {
          border-color: #D96B2C !important;
        }
      `}</style>
      <div className="bg-cream text-navy">
        <nav className="navbar navbar-expand-lg bg-white shadow-sm py-2">
          <div className="container">
            <a className="navbar-brand ">
              <div className="col-3">
                <ImageWithBasePath
                  src="assets/img/logo.png"
                  alt="logo"
                  className="img-fluid"
                />
              </div>
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navMenu"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navMenu">
              <ul className="navbar-nav ms-auto gap-lg-4 text-center">
                <li className="nav-item">
                  <a
                    className="nav-link fw-medium text-navy text-nowrap"
                    href="#"
                  >
                    <i className="ti ti-brand-whatsapp"></i>
                    <span>+91-8297230010</span>
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link fw-medium text-navy text-nowrap"
                    href="#"
                  >
                    <i className="ti ti-phone-call"></i>
                    <span>+91-8297230010</span>
                  </a>
                </li>
                <li className="nav-item">
                  <div
                    className="nav-link fw-medium text-navy text-nowrap"
                    href="#"
                  >
                    <a
                      href="https://www.youtube.com/@perecoindia"
                      aria-label="Location"
                    >
                      <i className="ti ti-brand-youtube-filled text-danger fs-4"></i>
                    </a>
                    <a
                      href="https://www.facebook.com/Perecoindia/"
                      aria-label="Facebook"
                    >
                      <i
                        className="ti ti-brand-facebook-filled fs-4"
                        style={{ color: "#2563eb" }}
                      ></i>
                    </a>
                    <a
                      href="https://www.instagram.com/pereco_india/"
                      aria-label="Verified"
                    >
                      <i
                        className="ti ti-brand-instagram fs-4"
                        style={{ color: "#E34B4A" }}
                      ></i>
                    </a>
                    <a href="https://x.com/PerecoIndia" aria-label="Twitter">
                      <i className="ti ti-brand-x-filled fs-4"></i>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        <header className="py-2">
          <div className="container py-2">
            <div className="row align-items-start g-5">
              <div className="col-lg-8">
                <div>
                  {" "}
                  <h1 className="fw-bold display-1 mb-0">
                    Seamless Growth, Made Possible.
                  </h1>
                  <hr
                    className="border-4 border-terracotta opacity-100 my-1"
                    style={{ width: "140px" }}
                  />
                  <p className="text-secondary mb-2 w-75">
                    We craft brands, websites and digital products for
                    businesses across industries.
                  </p>
                  <div className="d-flex flex-wrap gap-3">
                    <a
                      href="https://www.perennialcode.in/solutions"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn text-white rounded-pill fw-semibold px-4 py-2"
                      style={{ backgroundColor: "#D96B2C" }}
                    >
                      Explore Our Work
                    </a>
                    <a
                      href="https://www.perennialcode.in/contactus"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn rounded-pill fw-semibold px-4 py-2"
                      style={{
                        border: "2px solid #D96B2C",
                        color: "#D96B2C",
                      }}
                    >
                      Get in Touch
                    </a>
                  </div>
                </div>
                <div className="row mt-1 g-3 text-center">
                  <div className="col-md-3 col-6">
                    <div className="py-3 shadow rounded-4">
                      <div
                        className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                        style={{
                          width: "70px",
                          height: "70px",
                          background: "#FBE8DA",
                        }}
                      >
                        <i
                          className="fas fa-shield-alt"
                          style={{
                            color: "#D96B2C",
                            fontSize: "30px",
                          }}
                        ></i>
                      </div>
                      <h5 className="fw-bold text-navy mb-1">
                        Secure & Reliable
                      </h5>
                    </div>
                  </div>

                  <div className="col-md-3 col-6">
                    <div className="py-3 shadow rounded-4">
                      <div
                        className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                        style={{
                          width: "70px",
                          height: "70px",
                          background: "#FBE8DA",
                        }}
                      >
                        <i
                          className="fas fa-bolt"
                          style={{
                            color: "#D96B2C",
                            fontSize: "30px",
                          }}
                        ></i>
                      </div>
                      <h5 className="fw-bold text-navy mb-1">Fast & Simple</h5>
                    </div>
                  </div>

                  <div className="col-md-3 col-6">
                    <div className="py-3 shadow rounded-4">
                      <div
                        className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                        style={{
                          width: "70px",
                          height: "70px",
                          background: "#FBE8DA",
                        }}
                      >
                        <i
                          className="fas fa-mobile-alt"
                          style={{
                            color: "#D96B2C",
                            fontSize: "30px",
                          }}
                        ></i>
                      </div>

                      <h5 className="fw-bold text-navy mb-1">
                        Mobile Friendly
                      </h5>
                    </div>
                  </div>

                  <div className="col-md-3 col-6">
                    <div className="py-3 shadow rounded-4">
                      <div
                        className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                        style={{
                          width: "70px",
                          height: "70px",
                          background: "#FBE8DA",
                        }}
                      >
                        <i
                          className="fas fa-headset"
                          style={{
                            color: "#D96B2C",
                            fontSize: "30px",
                          }}
                        ></i>
                      </div>

                      <h5 className="fw-bold text-navy mb-1">
                        Always Supported
                      </h5>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <div
                  className="card border-0 shadow rounded-4 mx-auto"
                  style={{ maxWidth: "380px" }}
                >
                  <div className="card-body p-4 px-md-5 py-4">
                    <h4 className="fw-bold mb-1">Welcome Back</h4>

                    <form onSubmit={handleLogin}>
                      <div className="mb-3 text-start">
                        <label
                          htmlFor="username"
                          className="form-label fw-medium small"
                        >
                          Username
                        </label>
                        <input
                          type="text"
                          className="form-control bg-cream"
                          id="username"
                          placeholder="Enter your username"
                          value={Username}
                          onChange={(e) => setUserName(e.target.value)}
                        />
                      </div>
                      <label
                        htmlFor="password"
                        className="form-label fw-medium small"
                      >
                        Password
                      </label>
                      <div className="mb-4 text-start input-group">
                        <input
                          type={isPasswordVisible ? "text" : "password"}
                          className="form-control bg-cream"
                          id="password"
                          placeholder="Enter your password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                        <button
                          type="button"
                          className="input-group-text bg-white border"
                          onClick={togglePasswordVisibility}
                          style={{ cursor: "pointer" }}
                        >
                          <i
                            className={`ti ${
                              isPasswordVisible ? "ti-eye" : "ti-eye-off"
                            }`}
                          />
                        </button>
                      </div>
                      <button
                        type="submit"
                        className="btn text-white w-100 py-2 fw-semibold rounded-3"
                        disabled={loading}
                        style={{ backgroundColor: "#D96B2C" }}
                      >
                        {loading ? (
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                          />
                        ) : (
                          "Sign In"
                        )}
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
        <Spin spinning={dataloading} size="large" tip="Loading...">
          <section className="mb-4">
            <div className="container text-center">
              <p
                className="text-terracotta fw-bold small mb-1"
                style={{ letterSpacing: "1px" }}
              >
                OUR CLIENTS
              </p>
              <h2 className="fw-bold mb-3">Who We Work With</h2>
              <style>
                {`.img-blurred-bg {
                filter: blur(20px) brightness(0.7);
                transform: scale(1.15);
              }`}
              </style>
              <div className="row">
                <div className="col-8">
                  <Slider {...settings}>
                    {featureCards.map((item, index) => {
                      const isFallback = item.isFallback;

                      return (
                        <div key={index}>
                          <div
                            className="card border-0 shadow-sm rounded-4 overflow-hidden"
                            style={{ height: carouselHeight }}
                          >
                            <div
                              className="position-relative bg-light"
                              style={{
                                aspectRatio: "9 / 16",
                                overflow: "hidden",
                              }}
                            >
                              {/* Background Image */}
                              {isFallback ? (
                                <ImageWithBasePath
                                  src={item.image}
                                  alt={item.title}
                                  className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover img-blurred-bg"
                                />
                              ) : (
                                <img
                                  src={item.image}
                                  alt={item.title}
                                  className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover img-blurred-bg"
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src =
                                      ImagesCrousel[
                                        index % ImagesCrousel.length
                                      ].image;
                                  }}
                                />
                              )}

                              {/* Main Image */}
                              {isFallback ? (
                                <ImageWithBasePath
                                  src={item.image}
                                  alt={item.title}
                                  className="position-absolute top-0 start-0 w-100 h-100 object-fit-contain"
                                />
                              ) : (
                                <img
                                  src={item.image}
                                  alt={item.title}
                                  className="position-absolute top-0 start-0 w-100 h-100 object-fit-contain"
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src =
                                      ImagesCrousel[
                                        index % ImagesCrousel.length
                                      ].image;
                                  }}
                                />
                              )}

                              {item.category && (
                                <span className="position-absolute top-0 end-0 m-2 badge bg-white text-navy rounded-pill fw-medium">
                                  {item.category}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </Slider>
                </div>
                <div className="col-4">
                  <Slider {...verticalSettings}>
                    {featureCarouselSlides.map((item, index) => {
                      const isFallback = item.image?.startsWith("assets/");

                      return (
                        <div key={index}>
                          <div
                            className="card border-0 shadow-sm rounded-4 overflow-hidden"
                            style={{
                              height: carouselHeight / 2 - 10,
                            }}
                          >
                            <div
                              className="position-relative bg-light"
                              style={{
                                aspectRatio: "3 / 2",
                                overflow: "hidden",
                              }}
                            >
                              {/* Background Image */}
                              {isFallback ? (
                                <ImageWithBasePath
                                  src={item.image}
                                  alt={item.title || ""}
                                  className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover img-blurred-bg"
                                />
                              ) : (
                                <img
                                  src={item.image}
                                  alt={item.title || ""}
                                  className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover img-blurred-bg"
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src =
                                      ImagesCrouselVertical[
                                        index % ImagesCrouselVertical.length
                                      ].image;
                                  }}
                                />
                              )}

                              {/* Main Image */}
                              {isFallback ? (
                                <ImageWithBasePath
                                  src={item.image}
                                  alt={item.title || ""}
                                  className="position-absolute top-0 start-0 w-100 h-100 object-fit-contain"
                                />
                              ) : (
                                <img
                                  src={item.image}
                                  alt={item.title || ""}
                                  className="position-absolute top-0 start-0 w-100 h-100 object-fit-contain"
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src =
                                      ImagesCrouselVertical[
                                        index % ImagesCrouselVertical.length
                                      ].image;
                                  }}
                                />
                              )}

                              {item.category && (
                                <span className="position-absolute top-0 end-0 m-2 badge bg-white text-navy rounded-pill fw-medium">
                                  {item.category}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </Slider>
                </div>
              </div>
            </div>
          </section>
        </Spin>
        <footer className="bg-terracotta text-white pt-4">
          <div className="container">
            <div className="row">
              <div className="col-md-6 mb-3 text-start overview-text">
                <ImageWithBasePath
                  src="assets/img/full logo- white.avif"
                  alt="logo"
                  className="img-fluid"
                />
                <div className="mt-3 text-start d-flex align-items-center">
                  <a
                    href="https://www.instagram.com/pereco_india/?igsh=MXFrNXRieHozMHVicA%3D%3D#"
                    className="text-white me-2"
                  >
                    <i className="fa-brands fs-2 fa-instagram"></i>
                  </a>
                  <a
                    href="https://www.facebook.com/Perecoindia/"
                    className="text-white me-2"
                  >
                    <i className="fa-brands fs-2 fa-facebook"></i>
                  </a>
                  <a
                    href="https://x.com/PerecoIndia"
                    className="text-white me-2"
                  >
                    <i className="fa-brands fs-2 fa-x-twitter"></i>
                  </a>
                  <a
                    href="https://www.linkedin.com/company/perennial-code/"
                    className="text-white me-2"
                  >
                    <i className="fa-brands fs-2 fa-linkedin"></i>
                  </a>
                  <a
                    href="https://www.youtube.com/@perecoindia"
                    className="text-white me-2"
                  >
                    <i className="fa-brands fs-2 fa-youtube"></i>
                  </a>
                </div>

                <div className="mt-3 text-start">
                  <a
                    href="https://www.google.com/maps/dir//opp.+ASK+Educational+Society,+Vittal+Nagar,+Adikmet,+Hyderabad,+Telangana+500044/@17.4059614,78.4262689,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bcb99a6320e26bb:0x199d77b1f4faac56!2m2!1d78.5086707!2d17.4059783?entry=ttu"
                    className="text-white text-decoration-none d-inline-flex align-items-start justify-content-center"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-solid fa-location-dot fs-2 me-2 mt-1"></i>
                    <span className="text-start">
                      <span className="d-block">
                        Vidya Nagar Street Number 7,{" "}
                      </span>
                      <span className="d-block">
                        Hyderabad,Telangana, 500044
                      </span>
                    </span>
                  </a>
                </div>
              </div>
              <div className="col-md-6 mb-3 overview-text">
                <div className="row">
                  <div className="col-7 mb-5 text-start overview-text">
                    <h4 className="text-white d-inline-block border-bottom border-2 border-white">
                      Contact
                    </h4>

                    <p className="small">
                      <i className="fa-solid fs-4 fa-phone me-2 mt-1"></i> +91
                      8297230010
                    </p>
                    <div className="d-flex align-items-start mb-3 small">
                      <i className="fa-solid fa-envelope fs-4 me-2"></i>

                      <ul className="mb-0 list-unstyled">
                        <li>sales@perennialcode.in</li>
                        <li>support@perennialcode.in</li>
                        <li>info@perennialcode.in</li>
                      </ul>
                    </div>
                  </div>

                  <div className="col-5 text-start overview-text">
                    <h5 className="text-white d-inline-block border-bottom border-2 border-white">
                      Quick Links
                    </h5>
                    <ul className="list-unstyled">
                      <li>
                        <a
                          href="https://www.perennialcode.in/aboutus"
                          className="text-white text-decoration-none"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          About Us
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.perennialcode.in/solutions"
                          className="text-white text-decoration-none"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Solutions
                        </a>
                      </li>

                      <li>
                        <a
                          href="https://www.perennialcode.in/contactus"
                          className="text-white text-decoration-none"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Contact Us
                        </a>
                      </li>

                      <li>
                        <a
                          href="https://rollcall.perennialcode.in/"
                          className="text-white text-decoration-none"
                        >
                          Demo Application
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <hr className="border-light" />

            <div className="text-center small">
              © 2025 Perennial Code. All Rights Reserved.
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Signin;
